/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { maxContentWidth } from './footer/styled';
const contentStyles = css({
  flex: 1,
  overflow: 'auto'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
export const DrawerWrapper = styled.div({
  flexGrow: 1,
  display: 'flex',
  height: '100%',
  flexDirection: 'column',
  boxSizing: 'border-box',
  overflow: 'auto'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
export const DrawerContainer = styled.div({
  display: 'flex',
  height: '100%',
  boxSizing: 'border-box'
});

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ParentContentWrapper = styled.div`
	flex: 1 1 0%;
	overflow-y: scroll;
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ContentWrapper = styled.div`
	margin: 0 auto;
	box-sizing: border-box;
	padding: ${"var(--ds-space-800, 64px)"} ${"var(--ds-space-800, 64px)"} ${"var(--ds-space-400, 32px)"}
		${"var(--ds-space-800, 64px)"};
	max-width: ${({
  contentSize
}) => maxContentWidth[contentSize]};
`;
export const SidebarOverride = () => {
  return null;
};
export const ContentOverride = ({
  children
}) => {
  return jsx("div", {
    css: contentStyles
  }, children);
};